<template>
  <div v-show="hasInvoices">
    <p class="font-weight-bold body-1">{{ title }}</p>
    <div v-for="customer in invoices" :key="customer.id">
      <v-card class="mb-10" outlined>
        <v-data-table :items="transformInToArray(customer.branches)" :headers="branchHeaders" hide-default-footer calculate-widths disable-sort show-expand>
          <template v-slot:item.customer="{ item }">
            {{ customer.name }}
            <small class="d-block grey--text">{{ maskCnpj(customer.cnpj) }}</small>
          </template>
          <template v-slot:item.name="{ item }">
            {{ item.name }}
            <small class="d-block grey--text">{{ maskCnpj(item.cnpj) }}</small>
          </template>
          <template v-slot:item.total="{ item }">
            {{ formatMoney(item.total) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu offset-y bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="sendInvoice(item)">
                  <v-icon class="mr-3 grey--text text--lighten-1" small left>mdi-upload-box-outline</v-icon>
                  <v-list-item-title class="d-flex">
                    {{ $t('hausefulInvoices.actions.sendInvoice') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td :colspan="headers.length" class="content pl-13 pb-10">
              <v-card class="rounded-b-lg" outlined>
                <v-data-table
                  :items="item.payments"
                  :headers="invoiceHeaders"
                  hide-default-footer
                  disable-sort
                  items-per-page="1000"
                >
                  <template v-slot:item.code="{ item }">
                    {{ code(item.code) }}
                  </template>
                  <template v-slot:item.date="{ item }">
                    {{ formatDate(item.date) }}
                  </template>
                  <template v-slot:item.value="{ item }">
                    {{ formatMoney(item.value) }}
                  </template>
                </v-data-table>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { maskCnpj } from '@/util/masks'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { branchHeaders, invoiceHeaders } from '../../hostInvoiceHeaders'

export default {
  name: 'HostInvoiceFortnight',

  props: {
    title: {
      type: String,
      required: true,
    },

    invoices: {
      type: Array,
      required: false,
    },
  },

  computed: {
    hasInvoices() {
      return this.invoices?.length > 0
    },
  },

  methods: {
    ...mapActions(['openModal', 'showErrorMessage']),

    code(code) {
      return code ?? '---'
    },

    transformInToArray(branches) {
      if (!branches) return []
      return Object.values(branches)
    },

    getPaymentsIds(payments) {
      return payments.map(payment => payment.id)
    },

    sendInvoice(invoice) {
      const invoice_id = invoice.id
      const payment_ids = this.getPaymentsIds(invoice.payments)
      const branch = {
        name: invoice.name,
        cnpj: invoice.cnpj,
        total: invoice.total,
      }

      this.$emit('sendInvoiceData', { invoice_id, payment_ids, branch })
      this.openModal('SEND_HOST_INVOICE_MODAL')
    },

    maskCnpj,
  },

  data() {
    return {
      branchHeaders,
      invoiceHeaders,
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
    }
  }
}
</script>
